import { render } from "./genericSetCRUD.vue?vue&type=template&id=079d555e&scoped=true"
import script from "./genericSetCRUD.vue?vue&type=script&lang=js"
export * from "./genericSetCRUD.vue?vue&type=script&lang=js"

import "./genericSetCRUD.vue?vue&type=style&index=0&id=079d555e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079d555e"]])

export default __exports__